import { service } from './service'
import {LoginData} from '@/views/login/type'

export const testApi = (data:any) => {
    return service(

        {
            url: "/njcb/test",
            method:'post',
            data
        }
    )
}


export const loginApi = (data:LoginData) => {
    return service(

        {
            url: "/api/login",
            method:'post',
            data
        }
    )
}

//获取用户列表
// export const getuserApi = (params)=>{

//     return get(
//         true,
//         {
//             url:"/my/userlist",
//             params :{
//                 ...params
//             }
//         }
//     )
// }

export const getuserApi = (params:any) => {
    return service({
        url: "/my/userlist",
        method:'get',
        params: {
            ...params
        }
    })
}



//根据id删除用户
export const delUserApi = (data:any) => {

    return service(

        {
            url: "/my/del",
            method:'post',
            data
        }
    )
}

//修改用户status
export const updateUserStatusApi = (data:any) => {
    return service(

        {
            url: "/my/updateStatus",
            method:'post',
            data
        }
    )
}

//新增用户
export const addUserApi = (data:any) => {
    return service(

        {
            url: "/api/reg",
            data,
            method:'post'
        }
    )
}

//编辑用户
export const editUserApi = (data:any) => {
    return service(

        {
            url: "/my/editUser",
            method:'post',
            data
        }
    )
}

//银行相关

//子账户开户
export const addSubAccount = (data:any) => {
    return service(

        {
            url: "/njcb/addSubAccount",
            method:'post',
            data
        }
    )
}

//获取银行子账户列表
export const getSubAccountList = (data:any) => {
    return service(

        {
            url: "/njcb/subAccountList",
            method:'post',
            data
        }
    )
}


//同步银行子账户列表及子账户余额
export const syncSubAccountList = (data:any) => {
    return service(

        {
            url: "/njcb/syncSubAccountList",
            method:'post',
            data
        } 
    )
}
//导出银行子账户列表及子账户余额
export const exportSubAccountList = (data:any) => {
    return service(

        {
            url: "/njcb/exportSubAccountList",
            method:'post',
            data
        } 
    )
}


//获取银行子账户列表(根据账户名称模糊查询)
export const getSubAccountListByName = (data:any) => {
    return service(

        {
            url: "/njcb/subAccountListByName",
            method:'post',
            data
        }
    )
}
//获取银行子账户列表(从本地数据库查询)
export const getSubAccountListFromLocal = (data:any) => {
    return service(

        {
            url: "/njcb/subAccountListFromLocal",
            method:'post',
            data
        }
    )
}

//获取银行子账户详细流水
export const getSubAccountDetail = (data:any) => {
    return service(

        {
            url: "/njcb/subAccountDetail",
            method:'post',
            data
        }
    )
}

//获取子账户余额

export const getSubAccountBalance = (data:any) => {
    return service(

        {
            url: "/njcb/subAccountBalance",
            method:'post',
            data
        }
    )
}

//获取所有子账户总额

export const getSubAccountsTotal = (data:any) => {
    return service(

        {
            url: "/njcb/subAccountsTotal",
            method:'post',
            data
        }
    )
}


//获取转他行总额

export const getToOtherBankAmount = (data:any) => {
    return service(

        {
            url: "/zjtj/sevenall",
            method:'post',
            data
        }
    )
}
//获取转他行总额

export const getToOtherBankAmountBySubAccount = (data:any) => {
    return service(

        {
            url: "/zjtj/sevenallbysubaccount",
            method:'post',
            data
        }
    )
}

//获取通知存款列表
export const getTzckList = (data:any) => {
    return service(

        {
            url: "/njcb/tzckList",
            method:'post',
            data
        }
    )
}

//获取通知存款列表(根据账户名称或者金额范围)
export const getTzckLsitBySearchKey = (data:any) => {
    return service(

        {
            url: "/njcb/tzckListBySearchKey",
            method:'post',
            data
        }
    )
}

//通知存款开立
export const addTzckNotice = (data:any) => {
    return service(

        {
            url: "/njcb/addTzckNotice",
            method:'post',
            data
        }
    )
}

//通知存款开立
export const tzckDraw = (data:any) => {
    return service(

        {
            url: "/njcb/tzckDraw",
            method:'post',
            data
        }
    )
}

//通知存款获取基准利率
export const tzckJzlv = (data:any) => {
    return service(

        {
            url: "/njcb/tzckJzlv",
            method:'post',
            data
        }
    )
}

//通知存款获取实际利率
export const tzckSjlv = (data:any) => {
    return service(

        {
            url: "/njcb/tzckSjlv",
            method:'post',
            data
        }
    )
}

//回单查询
export const getHdcxList = (data:any) => {
    return service(

        {
            url: "/njcb/hdcxList",
            method:'post',
            data
        }
    )
}

//通知存款全量试算
export const tzckTotalCompute = (data:any) => {
    return service(

        {
            url: "/njcb/tzckTotalCompute",
            method:'post',
            data
        }
    )
}
//存款试算
export const tzckCompute = (data:any) => {
    return service(

        {
            url: "/njcb/tzckCompute",
            method:'post',
            data
        }
    )
}

//获取手工清分列表
export const getSgqfList = (data:any) => {
    return service(

        {
            url: "/njcb/sgqfList",
            method:'post',
            data
        }
    )
}
//手工清分
export const sgqfAct = (data:any) => {
    return service(

        {
            url: "/njcb/sgqfAct",
            method:'post',
            data
        }
    )
}

//下载开户文档
export const downKaihu = (data:any) => {
    return service(

        {
            url: "/njcb/downKaihu",
            method:'post',
            data,
            responseType: 'arraybuffer'
        }
    )
}


//下载销户文档
export const downXiaohu = (data:any) => {
    return service(

        {
            url: "/njcb/downXiaohu",
            method:'post',
            data,
            responseType: 'arraybuffer'
        }
    )
}

//手工记录资金
export const recordMoney = (data:any) => {
    return service(

        {
            url: "/zjtj/record",
            method:'post',
            data,
        }
    )
}

//手工记录资金列表
export const getRecordList = (data:any) => {
    return service(

        {
            url: "/zjtj/list",
            method:'post',
            data,
        }
    )
}

//下载资金记录文档
export const downRecord = (data:any) => {
    return service(

        {
            url: "/zjtj/downRecord",
            method:'post',
            data,
            responseType: 'arraybuffer'
        }
    )
}

//获取银行子账户列表(从本地数据库查询)
export const getOtherBank = (data:any) => {
    return service(

        {
            url: "/zjtj/otherBankList",
            method:'post',
            data
        }
    )
}

//手工记录资金
export const addRecord = (data:any) => {
    return service(

        {
            url: "/zjtj/addRecord",
            method:'post',
            data,
        }
    )
}

//手工记录资金列表
export const getRecordsList = (data:any) => {
    return service(

        {
            url: "/zjtj/recordsList",
            method:'post',
            data,
        }
    )
}
//他行总账
export const getOtherBankAll = (data:any) => {
    return service(

        {
            url: "/zjtj/otherBankAll",
            method:'post',
            data,
        }
    )
}

//子账户他行总账
export const getOtherBankSubAccountAll = (data:any) => {
    return service(

        {
            url: "/zjtj/otherBankSubAccountall",
            method:'post',
            data,
        }
    )
}